<template>
  <div>
    <div class="container h-100">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-md-6 text-center">
          <img src="@/assets/img/onboardings/questions.svg" width="200px" class="img-fluid mb-5"
               alt="Colorffy logo">
          <h4 class="fw-bold mb-3">Forgot your password?</h4>
          <h6 class="subtitle-1 text-muted mb-4">Don't worry! Resetting your password it's easy. Enter your email
            address you're using for
            your account below and we'll send you a password reset link.</h6>

          <form action="" @submit.prevent="onSubmit">
            <div class="form-floating mb-3">
              <input type="email" class="form-control" id="inputEmail" placeholder="name@example.com" required
                     v-model="form.email">
              <label for="inputEmail">Email address</label>
            </div>
            <div class="d-grid gap-2 mt-3">
              <button type="submit" class="btn btn-primary ripple py-3">Request reset link</button>
            </div>
          </form>

          <div class="text-center mt-3">
            <router-link to="/login" class="text-body">Already have an account? <span
                class="text-link text-underline">Sign in</span></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
  name: 'ForgotPassword',
  metaInfo: {
    title: 'Forgot Password'
  },
  data() {
    return {
      form: {
        email: "",
      },
      error: null,
      emailSending: false,
    }
  },
  methods: {
    onSubmit() {
      this.emailSending = true;

      firebase
          .auth()
          .sendPasswordResetEmail(this.form.email)
          .then(() => {
            this.emailSending = false
            this.$swal({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              icon: 'success',
              title: 'Request link sent!',
            })
            console.log('Email request link sent!')
          })
          .catch(error => {
            this.emailSending = false
            this.error = error.message
          })
    }
  }
}
</script>